import React from 'react';
import styled from 'styled-components';
import { arrayOf, bool, element, oneOfType } from 'prop-types';
import Wrapper from '../Wrapper';

import {
  PriceOffTextV2,
  PriceOffText,
  SubtitleText,
  TitleText,
  HintText,
} from './CardText';

export const PlainCard = styled(Wrapper)`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16);
  position: relative;
  outline: none;
  cursor: initial;
`;

const StyledPlainCard = styled(PlainCard)`
  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

const FocusOutline = styled.span`
  display: none;
  outline: none;
  position: absolute;
  top: -8px;
  bottom: -8px;
  right: -8px;
  left: -8px;
  width: calc(100% + 14px);
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 6px;

  ${StyledPlainCard}:focus & {
    display: block;
  }
`;

const Card = ({ focusable, children, ...restProps }) => (
  <StyledPlainCard {...restProps} tabIndex={focusable ? 0 : 'unset'}>
    <FocusOutline />
    {children}
  </StyledPlainCard>
);

Card.propTypes = {
  focusable: bool,
  children: oneOfType([element, arrayOf(element)]),
};

Card.defaultProps = {
  borderRadius: '4px',
};

Card.TitleText = TitleText;
Card.SubtitleText = SubtitleText;
Card.PriceOffText = PriceOffText;
Card.PriceOffTextV2 = PriceOffTextV2;
Card.HintText = HintText;

export default Card;
